import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useSelector } from 'statux'

import RichText from '../../../components/RichText/RichText'
import Details from '../../../components/Details/Details'

import { getCssVar } from '../../../utils/css'
import { graphqlClient, gql } from '../../../utils/gql'

import authProvider from '../../../utils/auth-provider'

export default function DashboardEbpcJudgeOrientation (props = {
    heading: null,
    richText: null,
    aside: null,
    accordions: null
}) {
    const userId = (authProvider.getIdentity() || {}).id

    const isEbpcJudge = authProvider.getDefaultRole() === 'ebpc_judge'

    const history = useHistory()

    const {
        ebpcContest,
        ebpcAssignmentsOpen,
        ebpcFinalsOpen
    } = useSelector()

    const [assignments, setAssignments] = useState(
        ebpcAssignmentsOpen
                || ebpcFinalsOpen
            ? (history.location.state || {}).ebpcAssignments
                || null
            : [])

    useEffect(async () => {
        if (!isEbpcJudge)
            return history.push('/dashboard')

        if (!userId
                || (!ebpcAssignmentsOpen
                    && !ebpcFinalsOpen))
            return !ebpcAssignmentsOpen
                && !ebpcFinalsOpen
                && setAssignments([])

        const query = await graphqlClient
            .request(gql`
                query {
                    ebpc_assignments (
                        where: {
                            ebpc_judge_id: {
                                _eq: "${userId}"
                            },
                            ebpc_application: {
                                ebpc_contest_id: {
                                    _eq: ${ebpcContest.id}
                                },
                                submitted_at: {
                                    _is_null: false
                                }
                            }
                            ebpc_finals: {
                                _eq: ${ebpcFinalsOpen}
                            },
                            recused_at: {
                                _is_null: true
                            }
                        },
                        order_by: {
                            ebpc_application_id: asc
                        }
                    ) {
                        ebpc_application {
                            profile {
                                user {
                                    id
                                }
                            }
                        }
                    }
                }`)
            .then(obj => obj.ebpc_assignments)
            .catch((err) => {
                console.warn(err)
                return []
            })

        if (JSON.stringify(assignments)
                === JSON.stringify(query))
            return

        setAssignments(query)

        history.replace(
            `${history.location.pathname}${history.location.search}`,
            Object.assign(history.location.state || {}, {
                ebpcAssignments: query
            }))
    }, [])

    if (!isEbpcJudge)
        return null

    return (
        <div className="dashboard-ebpc-judge-orientation pad-3-t pad-4-b pad-4-t-lg-up">
            <div className="container">
                {props.heading
                    && (
                        <div className="row-condensed margin-3-b">
                            <div className="col-12 col-8-xl-up">
                                <h1 className="heading-2 margin-b">{props.heading}</h1>
                                <div className="display-flex flex-align-items-center">
                                    <Link
                                        to="/dashboard"
                                        className="body-4 display-inline-flex"
                                        style={{
                                            color: getCssVar('--slate'),
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <svg
                                            className="icon-chevron-left flex-none"
                                            width="18"
                                            height="18"
                                            style={{ margin: '-2px 2px 0 -5px' }}
                                        >
                                            <use xlinkHref="#icon-chevron-left" />
                                        </svg>
                                        <span>
                                            <span className="display-none-sm-down">Go back </span>
                                            <span className="text-transform-capitalize display-none-sm-up">back </span>
                                            to EBPC judging portal
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>)}
                {(props.richText
                        || (props.accordions || []).length)
                    && (
                        <div className="row-condensed">
                            <div className="col-12 col-8-xl-up">
                                <section className="dashboard-ebpc-judge-orientation-content card card-offscreen-x-lg-down body-3">
                                    <RichText
                                        html={props.richText}
                                        className="margin-4-b"
                                    />
                                    {(props.accordions || [])
                                        .map((obj, idx) => (
                                            <Details
                                                key={`dashboard-ebpc-judge-orientation-accordion-${idx}`}
                                                className={`card card-border${
                                                    idx
                                                        ? ' margin-t'
                                                        : ''}`}
                                                {...obj}
                                            />
                                        ))}
                                </section>
                            </div>
                            {Boolean((assignments || []).length)
                                && (
                                    <aside className="col margin-3-t-lg margin-1-t-lg-down">
                                        <div className="card card-offscreen-x-lg-down">
                                            <RichText
                                                html={(props.aside || {}).richText}
                                                className="body-4 margin-b"
                                            />
                                            <Link
                                                to={`/dashboard/ebpc/applications/${
                                                    assignments[0].ebpc_application.profile.user.id}`}
                                                className="btn btn-secondary"
                                                style={{
                                                    paddingTop: 15,
                                                    paddingBottom: 15
                                                }}
                                            >
                                                {((props.aside || {}).cta || {}).text
                                                    || 'Review applications'}
                                            </Link>
                                        </div>
                                    </aside>)}
                        </div>)}
            </div>
        </div>
    )
}
